<template>
    <b-container fluid class="mt--7">
        <create-vehicle-form
            ref="createVehicle"
            @success="created"
        ></create-vehicle-form>

        <fleet-table
            title="Users"
            @addVehicle="showVehicleModal"
            ref="table"
        ></fleet-table>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import FleetTable from './FleetTable'
import CreateVehicleForm from './CreateVehicleForm'

export default {
    name: 'fleet',
    mixins: [popupMixins],
    components: {
        FleetTable,
        CreateVehicleForm,
    },
    data: () => {
        return {}
    },

    methods: {
        showVehicleModal() {
            this.$refs.createVehicle.showModal()
        },
        created() {
            this.doToast('Created!', 'Vehicle Created', 'success')
            this.$refs.table.doSearch()
        },
    },
}
</script>
<style></style>
